import { Component, OnInit } from '@angular/core'
import { CountryService } from './country.service'
import { CountryModel } from './country.model'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-country.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './country.master.component.html',
  styleUrl: './country.master.component.css',
})
export class CountryMasterComponent {
  countryColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'countryName',
      displayName: 'Country Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private countryService: CountryService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {
    this.masterCommonService.getAllCountries()
  }

  openAddUpdateCountryDialog(mode: string, country?: CountryModel): void {
    const fields = this.countryColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: country || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updateCountry(result)
        } else {
          this.addCountry(result)
        }
      }
    })
  }

  addCountry(country: any): void {
    this.countryService.addCountry(country).subscribe({
      next: () => {
        this.toastr.success('Country Added Successfully!', 'Success')
        this.masterCommonService.getAllCountries()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateCountry(country: any): void {
    this.countryService.updateCountry(country).subscribe({
      next: () => {
        this.toastr.success('Country Updated Successfully!', 'Success')
        this.masterCommonService.getAllCountries()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteCountry(country: CountryModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this country?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        country.isDeleted = true
        this.countryService.deleteCountry(country).subscribe({
          next: () => {
            this.masterCommonService.countriesList = this.masterCommonService.countriesList.filter(
              (p) => p.id !== country.id,
            )
            this.toastr.success('Country Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
